export const services = [
  {
    id: 1,
    name: 'Advanced style scissor cut',
    price: 7500,
    currency: 'usd',
    duration: 40,
  },
  {
    id: 2,
    name: 'Kids cut (under 12yrs)',
    price: 5000,
    currency: 'usd',
    duration: 45,
  },
  {
    id: 3,
    name: 'Signature clipper cut',
    price: 4000,
    currency: 'usd',
    duration: 30,
  },
  {
    id: 4,
    name: 'Mens clipper cut',
    price: 7500,
    currency: 'usd',
    duration: 75,
  },
  {
    id: 5,
    name: 'Beard Trim',
    price: 8000,
    currency: 'usd',
    duration: 30,
  },
  {
    id: 6,
    name: 'Premium Cut',
    price: 15000,
    currency: 'usd',
    duration: 90,
  },
  {
    id: 7,
    name: 'Haircut & hot towel',
    price: 7500,
    currency: 'usd',
    duration: 30,
  },
  {
    id: 8,
    name: 'Executive package',
    price: 9500,
    currency: 'usd',
    duration: 75,
  },
  {
    id: 9,
    name: 'Baldy shave',
    price: 5000,
    currency: 'usd',
    duration: 30,
  },
];
